import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAll,
    GetAllDedtuctionTypeNames,
    GetFieldsByCollectionPoint,
    GetDivisionByEstateID,
    GetWorkerCapturedAuditData,
    GetAvialableFieldsForDropdown
};

async function GetFieldsByCollectionPoint(id) {
    var response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    let array = [];
    for (let item of Object.entries(response.data)) {
        array[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return array;
}

async function getAll() {
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    return response.data;
}

async function GetAllDedtuctionTypeNames() {
    const response = await CommonGet('/api/DailyCollectionReport/GetDeductionTypeNamesForTable', null);
    return response.data;
}

async function GetDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        const entityData = item[1];
        
        if (entityData["isActive"] === true && entityData["operationEntityID"] == id) {
            if (entityData["operationEntityTypeID"] === 1) {
                if (entityData["collectionPointCategoryID"] === 3) {
                    divisionArray[entityData["collectionPointID"]] = entityData["collectionPointName"];
                }
            } else {
                divisionArray[entityData["collectionPointID"]] = entityData["collectionPointName"];
            }
        }
    }
    return divisionArray;
}


async function GetWorkerCapturedAuditData(data) {
    const searchDate = data.fromDate ?? data.searchDate;
    const searchData = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: data.divisionID === "0" ? null : data.divisionID,
        fieldID: data.fieldID === "0" ? null : data.fieldID,
        mode: data.mode === "0" ? null : parseInt(data.mode),
        fromDate: data.fromDate,
        toDate: data.toDate,

    }
    const response = await CommonPost('/api/WorkerCapturedAudit/GetWorkerCapturedAuditData', null, searchData);
    return response.data;
   
}

async function GetAvialableFieldsForDropdown(data) {
    var fieldArray = [];
    const searchDate = data.fromDate ?? data.searchDate;
    const searchData = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: data.divisionID,
        mode: data.mode === "0" ? null : parseInt(data.mode),
        pluckingType: data.mode === "0" ? null : parseInt(data.mode),
        fromDate: data.fromDate,
        toDate: data.toDate,

        searchDate: searchDate === "" ? null : searchDate
    }
    
    const response = await CommonPost('/api/WeighingReport/GetFieldsForCheckRollWeighmentReport', null, searchData);
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["fieldID"]] = item[1]["fieldName"]
    }
    return fieldArray;
}